import type { NavLeaf } from './navConfig';

/** Structural subset of `NavEntry` (useNavModel) so this file stays free of hooks. */
export interface TitleEntry {
  leaf: Pick<NavLeaf, 'path' | 'labelKey'>;
  /** i18n key of the containing group, or null for a root row. */
  groupLabelKey: string | null;
}

export interface TopBarTitleKeys {
  /** `shell.group.*` key, present only for a row inside a group. */
  groupKey: string | null;
  /** `shell.item.*` key of the page. */
  pageKey: string;
}

/**
 * Of every row the route lights up, the most specific one wins: the longest
 * path. A parent row (`/app/admin`) can never beat its child
 * (`/app/admin/map-pricing`). Ties keep sidebar order.
 */
export const pickActiveEntry = <E extends TitleEntry>(
  entries: E[],
  isActive: (leaf: E['leaf']) => boolean,
): E | null => {
  let best: E | null = null;
  entries.forEach((entry) => {
    if (!isActive(entry.leaf)) return;
    if (!best || entry.leaf.path.length > best.leaf.path.length) best = entry;
  });
  return best;
};

/** "Group / Page" for a grouped row, the row's own label alone for a root row, null for an unknown route. */
export const deriveTopBarTitle = (entry: TitleEntry | null): TopBarTitleKeys | null =>
  entry ? { groupKey: entry.groupLabelKey, pageKey: entry.leaf.labelKey } : null;
